module.exports = __webpack_public_path__ + "img/monitorbox19.e8ab66b3.jpg";